/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/SavedOrderCart',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Cart/all'
], function ($, _, Roc, Cart) {
    'use strict';

    var viewModel = {};

    var btns = {
        loadSavedCart: '[data-roc-action="loadSavedCart"]',
        removeSavedCart: '[data-roc-action="removeSavedCart"]',
        exportSavedCart: '[data-roc-action="exportSavedCart"]',

        expandSavedCart: '[data-roc-action="expandSavedCart"]',
        unexpandSavedCart: '[data-roc-action="unexpandSavedCart"]',
        startNewCart: '[data-roc-action="startNewCart"]'
    };

    /* Helpers UI */

    function showEmptyResultsMsg(selector) {
        // if a selector is passed in, utilize it, otherwise fall back to the error message selector from the viewmodel
        selector = selector || viewModel.errorMsgSelector;

        Roc.UI.template('#noEntryMsg-Tmp', { message: 'You do not have any saved Orders.' }).then(function (renderedTemplate) {
            $(selector).html(renderedTemplate);
        });
    }

    function checkEmptyResultsMsg() {
        if ($(viewModel.listSel + ' .slideItem:not(.slick-cloned)').length === 0) {
            showEmptyResultsMsg();
        }
    }

    function removeFromUi(listSel, noResultsSel, editId) {
        $(listSel + ' .slideItem[data-id=' + editId + ']:not(.slick-cloned)').hide('slow', function () {
            var idx = $('.slideItem:not(.slick-cloned)').index(this);
            $('.saved-carts-carousel-wrapper').slick('slickRemove', idx);

            checkEmptyResultsMsg();
        });
    };

    /* Events */

    function removeSavedCartEvt() {

        // customization for HT:
        // refactoring removeSavedCart to handle errors here, rather than through the CART_REMOVED event
        function doRemoveSavedCart(cartIdToRemove) {
            Cart.CartManager.removeSavedCart(cartIdToRemove)
                .then(function (data) {
                    removeFromUi('#saved-carts', '#noSavedCartsMsg', cartIdToRemove);
                })
                .fail(function (xhr) {
                    Roc.UI.ajaxErrorPopup(xhr);
                });
        }

        $(document)
            .off('click', btns.removeSavedCart)
            .on('click', btns.removeSavedCart, function (e) {

                var cartId = $(this).parents('.slideItem').attr('data-id');
                var deleteButton = $(e.currentTarget);

                Roc.Core.lockButton(deleteButton);

                Roc.UI.confirm({
                    "title": 'Delete Confirmation',
                    "message": 'Are you sure you want to delete this saved Order?',
                    "buttons": {
                        "Yes": {
                            "class": 'btn btnAction confirm',
                            "autoClose": true,
                            "action": function () {
                                // customized for HT: call direct removal function which will handle errors
                                doRemoveSavedCart(cartId);
                            }
                        },
                        "No": {
                            "class": 'btn',
                            "action": function () {
                                Roc.Core.releaseLockedButton(deleteButton);
                            }
                        }
                    }
                });
            });
    };

    function loadSavedCartEvt() {
        $(document)
            .off('click', btns.loadSavedCart)
            .on('click', btns.loadSavedCart, function (e) {

                var cartId = $(this).attr('data-id');
                var loadButton = $(e.currentTarget);

                Roc.Core.lockButton(loadButton);

                Roc.UI.confirm({
                    "title": 'Load Order',
                    "message": 'Do you want your current Order to be replaced with this saved Order?',
                    "buttons": {
                        "Continue": {
                            "class": 'btn btnAction confirm',
                            "autoClose": false,
                            "action": function () {
                                Cart.CartManager.loadSavedCart(cartId, {
                                    beforeSend: function() {
                                        Roc.Core.lockButton('.btn.btnAction.confirm');
                                    }
                                });

                                $.each(viewModel.orderCarts, function (index, value) {
                                    if (value.id === cartId) {
                                        Roc.EventManager.notify(Roc.Events.cart.LOAD_SAVED_CART, value.items);
                                    }
                                });
                            }
                        },
                        "Cancel": {
                            "class": 'btn',
                            "action": function () {
                                Roc.Core.releaseLockedButton(loadButton);
                            }
                        }
                    }
                });
            });

        function filterOutMessagesForDisplay(response) {
            var errors = 0;
            if (response.messages > 0) {
                _.each(response.addCartItemsResponse, function (response) {
                    response.errors = _.filter(response.errors, function (e) {
                        return e.errorMessage !== 'Sorry, this item is no longer available.';
                    });
                    errors += response.errors.length;
                });
                response.messages = errors;
            }
            return errors === 0;
        }

        Roc.EventManager.bind(Roc.Events.cart.CART_LOADED, function (xhr) {
            var response = xhr.responseJSON || {};
            var redirectToCart = response.orderId && filterOutMessagesForDisplay(response);
            if (redirectToCart) {
                window.location.href = '/cart';
            } else {
                if (response.messages > 0) {
                    var model = {};
                    model.heading = response.cart ? 'Your BOM has been loaded with problems:' :
                        'Errors occurred during your request and we were not able to load your BOMs.';
                    model.responses = response.addCartItemsResponse;

                    Roc.UI.template('#serviceErrors-Tmp', model).then(function (renderedTemplate) {
                        $('#confirmBox').html(renderedTemplate);
                    });

                    $('#confirmButtons .btn.btnAction.confirm').remove();
                    $('#confirmButtons .btn').text('Continue');
                } else {
                    Roc.UI.ajaxErrorPopup(xhr, response.message);
                    Roc.Core.releaseLockedButton('.btn.btnAction.confirm');
                }
            }
        });
    };

    function closeDetailsEvt() {
        Roc.UI.onCloseFormEvt(viewModel.listSel + ' .slideItem', function (ctx) {
            var id = $(ctx).attr('id');
            $('.btn[aria-controls=' + id + ']').text('Show Order');
        });
    }

    function openDetailsEvt() {
        Roc.UI.onOpenFormEvt(viewModel.listSel + ' .slideItem', function (ctx) {
            var id = $(ctx).attr('id');
            $('.btn[aria-controls=' + id + ']').text('Hide Order');
        });
    }

    function checkReorderStatus() {
        _.forEach(viewModel.orderCarts, function (order) {
            var availableItems = _.filter(order.items, function (i) {
                return i.product.canAddProduct;
            });
            order.allowToReorder = (availableItems.length > 0);
            order.canRemoveCart = viewModel.rocUserId === order.userId;
        });
    }

    // Start HT Customization : Exporting Saver Cart into an Excel File
    function exportSavedCartEvt() {
        $(document)
            .off('click', btns.exportSavedCart)
            .on('click', btns.exportSavedCart, function (e) {
                var cartId = $(this).attr('data-id');
                var exportButton = $(e.currentTarget);

                Roc.Core.lockButton(exportButton);

                $.each(viewModel.orderCarts, function (index, value) {
                    if (value.id === cartId) {
                        var request = prepareCartForExport(value);
                        $.ajax({
                            url: '/ajax/ExportExcel/',
                            contentType: 'application/json',
                            type: "POST",
                            data: JSON.stringify(request),
                        }).done(function (data) {
                            if (data.fileName !== "") {
                                window.location.href = '/ajax/Download?file=' + data.fileName;
                            }
                            else {
                                Roc.UI.ajaxErrorPopup(xhr, "An error occurred trying to export your BOM!");
                            }
                            Roc.Core.releaseLockedButton(exportButton);
                        })
                        .fail(function (data) {
                            Roc.UI.ajaxErrorPopup(xhr, "An error occurred trying to export your BOM!");
                            Roc.Core.releaseLockedButton(exportButton);
                        });                       
                    }
                });
            });

        function prepareCartForExport(currentCart) {
            var result = {};
            result.OrderNo = currentCart.orderCode;
            result.Items = [];
            for (var i = 0; i < currentCart.items.length; i++) {
                var item = {};
                item.Sku = currentCart.items[i].sku;
                item.Description = currentCart.items[i].product.shortDescription;
                item.Quantity = currentCart.items[i].quantity;
                item.Price = currentCart.items[i].price;
                if (itemHasProperty(currentCart.items[i], "package_Content")) {
                    item.Units = currentCart.items[i].product.customFields.package_Content[0].value;
                }
                result.Items.push(item);
            }
            return result;
        }

        function itemHasProperty(item, property) {
            return (typeof item.product.customFields !== "undefined" && property in item.product.customFields && item.product.customFields[property].length > 0)
        }
    }

    function onExpandSavedCart() {

        var cartId = $(this).parents('.slideItem').attr('data-id');

        var matchingCart = _.find(viewModel.orderCarts, function (cart) {
            return cart.id == cartId;
        });

        if (!matchingCart) {
            // exceptional case: should only happen if the ID in the dom doesn't match what came back from the API
            return;
        }

        Roc.UI.template('#htSavedOrderCart-Tmp', matchingCart).then(function (renderedTemplate) {
            $('#saved-bom-details').html(renderedTemplate);
        });

        toggleExpandSavedCartButton(cartId);
    }

    function onUnexpandSavedCart() {
        $('#saved-bom-details').html('');

        resetExpansionButtons();
    }

    function onStartNewCart() {
        Cart.CartManager.removeSavedCart('{orderId}')
            .then(function () {
                // redirect to search once the current cart has been cleared
                window.location = '/products';
            })
            .fail(function (xhr) {
                if (xhr && xhr.status === 404) {
                    // the API will return 404 if the current cart has already been deleted, in this case redirect to the search page
                    window.location = '/products';
                    return;
                }

                // otherwise, display an error
                Roc.UI.displayErrorPopup('An error occurred while attempting to start a new BOM. Please try again later.');
            });
    }

    function toggleExpandSavedCartButton(cartId) {

        // all buttons should be reset to unexpand
        resetExpansionButtons();
        
        var activeBtnSelector = '[data-roc-action$="expandSavedCart"][data-roc-id="' + cartId + '"]';
        var $activeBtn = $(activeBtnSelector);

        $activeBtn.text('Hide Order');
        $activeBtn.attr('data-roc-action', 'unexpandSavedCart');
    }

    function resetExpansionButtons() {
        var allBtnSelector = '[data-roc-action$="expandSavedCart"]';
        var $allBtns = $(allBtnSelector);

        $allBtns.text('Show Order');
        $allBtns.attr('data-roc-action', 'expandSavedCart');
    }

    // End HT Customization 

    function bindEvents() {
        removeSavedCartEvt();
        loadSavedCartEvt();
        closeDetailsEvt();
        openDetailsEvt();

        //HT Customizations below

        exportSavedCartEvt();
        
        Roc.UI.siteBody
            .off('click', btns.expandSavedCart)
            .on('click', btns.expandSavedCart, onExpandSavedCart);

        Roc.UI.siteBody
            .off('click', btns.unexpandSavedCart)
            .on('click', btns.unexpandSavedCart, onUnexpandSavedCart);

        Roc.UI.siteBody
            .off('click', btns.startNewCart)
            .on('click', btns.startNewCart, onStartNewCart);
    }

    /* Init */

    function loadCarts() {
        if (viewModel.orderCarts.length) {
            checkReorderStatus();

            Roc.UI.template('#savedOrderCart-Tmp', viewModel).then(function (renderedTemplate) {
                $(viewModel.targetSelector).html(renderedTemplate);
            });
        } else {
            showEmptyResultsMsg('#savedOrderCartWiget');
        }
    }

    function init(model) {
        viewModel = model;
        viewModel.targetSelector = '#savedOrderCartWiget';
        viewModel.errorMsgSelector = '.saved-carts-carousel';
        viewModel.listSel = '#saved-carts';
        loadCarts();
        bindEvents();
    };

    var SavedOrderCart = {
        init: init,
        viewModel: viewModel
    };

    Roc.Logger.debug('SavedOrderCart.js Loaded:', SavedOrderCart);

    return SavedOrderCart;
});
